import { render, staticRenderFns } from "./locationsTable.vue?vue&type=template&id=970baf74&"
import script from "./locationsTable.vue?vue&type=script&lang=ts&"
export * from "./locationsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports